import styled from 'styled-components';
import tw from 'twin.macro';

const commonStyling = (props) => [
  tw`mb-0 break-words min-w-0`,
  props.$truncate && tw`block truncate`, // only possible to truncate block elements

  /* the color prop
   *
   * propTypes: 'default', 'primary', 'black', 'gray dark', 'gray low', 'white'
   *
   */

  props.$color === 'default' && tw`text-black text-opacity-85`,
  props.$color === 'primary' && tw`text-blue-base`,
  props.$color === 'black' && tw`text-black text-opacity-85`,
  props.$color === 'gray dark' && tw`text-black text-opacity-60`,
  props.$color === 'gray light' && tw`text-black text-opacity-45`,
  props.$color === 'white' && tw`text-white`,
  props.$color === 'white light' && tw`text-white text-opacity-65`,
  props.$color === 'current' && tw`text-current`,

  /* the style prop
   *
   * propTypes: 'default', 'bold', 'italic'
   *
   */

  props.$textStyle === 'default' && tw`font-normal`,
  props.$textStyle === 'bold' && tw`font-bold`,
  props.$textStyle === 'italic' && tw`italic`,

  /* the transform prop
   *
   * propTypes: 'default', 'uppercase'
   */

  props.$transform === 'default' && tw`normal-case`,
  props.$transform === 'uppercase' && tw`uppercase`
];

const commonProps = (props) => ({
  $color: props.$color || props.color || 'default',
  $textStyle: props.$textStyle || props.textStyle,
  $transform: props.$transform || props.transform || 'default',
  $truncate: props.$truncate || props.truncate,
});

export const Title = styled.span.attrs((props) => commonProps(props))((props) => [
  tw`text-xl leading-normal`,
  ...commonStyling(props)
]);

export const Body = styled.span.attrs((props) => commonProps(props))((props) => [
  tw`text-lg leading-22`,
  ...commonStyling(props)
]);

export const Subhead = styled.span.attrs((props) => commonProps(props))((props) => [
  tw`text-md leading-20`,
  ...commonStyling(props)
]);

export const Meta = styled.span.attrs((props) => commonProps(props))((props) => [
  tw`text-sm leading-18`,
  ...commonStyling(props)
]);

export const Caption = styled.span.attrs((props) => commonProps(props))((props) => [
  tw`text-xs leading-16`,
  ...commonStyling(props)
]);

export const Link = styled.a.attrs((props) => commonProps(props))((props) => [
  tw`cursor-pointer hover:underline mb-0 break-words min-w-0`,
  props.$covert
    ? tw`transition opacity-100 active:opacity-50 hover:text-blue-base hover:text-opacity-95`
    : tw`text-blue-base text-opacity-95`
]);
